<template>
  <button-block
      :btnClass='disabled ? "btn-secondary" : btnClass'
      :text='text'
      :textIcon="textIcon"
      :sm="sm"
      :icon="icon"
      :disabled="disabled"
  />
</template>

<script>
import ButtonBlock from "./ButtonBlock";

export default {
  components: {ButtonBlock},
  data: function () {
    return {}
  },
  props: {
    btnClass: {
      type: String,
      default: 'btn-primary',
    },
    text: {
      type: String,
      default: 'Редактировать',
    },
    textIcon: {
      type: String,
      default: 'fas fa-edit',
    },
    sm: Boolean,
    icon: Boolean,
    disabled: Boolean,
  },
  computed: {},
  mounted() {

  },
  methods: {}
}
</script>
